import script from "./SnowOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./SnowOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./SnowOverlay.vue?vue&type=style&index=0&id=3f1cb908&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1cb908"]])

export default __exports__